// extracted by mini-css-extract-plugin
module.exports = {"rightMenuTabs":"RightMenuTabs_rightMenuTabs__1YTqc","tabGap":"RightMenuTabs_tabGap__ip-Nt"};